// Shared risk-parameter defaults for Compound V2 style forks.
// Applied when a fork exposes no comptroller-level or per-market value.
export const DEFAULT_CLOSE_FACTOR = 0.5
export const DEFAULT_LIQUIDATION_PENALTY = 0.08
